/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { containerCSS as compiledCSS, IndicatorsContainer as CompiledIndicatorsContainer, indicatorsContainerCSS as compiledIndicatorsContainerCSS, SelectContainer as CompiledSelectContainer, ValueContainer as CompiledValueContainer, valueContainerCSS as compiledValueContainerCSS } from '../compiled/components/containers';
import { containerCSS as emotionCSS, IndicatorsContainer as EmotionIndicatorsContainer, indicatorsContainerCSS as emotionIndicatorsContainerCSS, SelectContainer as EmotionSelectContainer, ValueContainer as EmotionValueContainer, valueContainerCSS as emotionValueContainerCSS } from '../emotion/components/containers';

// ==============================
// Root Container
// ==============================

export var containerCSS = function containerCSS(props) {
  return fg('compiled-react-select') ? compiledCSS() : emotionCSS(props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var SelectContainer = function SelectContainer(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledSelectContainer, props) : /*#__PURE__*/React.createElement(EmotionSelectContainer, props);
};

// ==============================
// Value Container
// ==============================

export var valueContainerCSS = function valueContainerCSS(props) {
  return fg('compiled-react-select') ? compiledValueContainerCSS() : emotionValueContainerCSS(props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var ValueContainer = function ValueContainer(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledValueContainer, props) : /*#__PURE__*/React.createElement(EmotionValueContainer, props);
};

// ==============================
// Indicator Container
// ==============================

export var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return fg('compiled-react-select') ? compiledIndicatorsContainerCSS() : emotionIndicatorsContainerCSS();
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var IndicatorsContainer = function IndicatorsContainer(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledIndicatorsContainer, props) : /*#__PURE__*/React.createElement(EmotionIndicatorsContainer, props);
};